import {postMethod} from '~/api'

async function post(request, params) {
    return await postMethod('/api/restorePassword', request, {params})
}

export {post}
